module.exports = __webpack_public_path__ + "assets/img/noClock.8602548c.png";